import { createAction, props } from '@ngrx/store';
import { changelogEntity } from './changelog.models';

export const loadChangelog = createAction('[Changelog] Load Changelog', props<{ language: string }>());

export const loadChangelogSuccess = createAction(
  '[Changelog] Load Changelog Success',
  props<{ changelog: changelogEntity }>()
);

export const loadChangelogFailure = createAction('[Changelog] Load Changelog Failure', props<{ error: any }>());
